export const STRINGS = {
  SELECT_LOGO: "Select Logo",
  BRAND_KIT: "Brand Kit",
  LOGO_URL: "Logo Url",
  APP_HEAD: "This applies across any reachiq accounts you have.",
  BRAND_DELETE: " Are you sure you want to Delete this Branding Detail?",
  SENDGRID: "sendgrid",
  GMAIL: "gmail",
  password: "password",
  MAILGUN: "mailgun",
  LOADING: "loading...",
  HOURLY: "Hourly",
  OLD: "Old Password",
  NEW: "New Password",
  CONFIRM: "Confirm New Password",
  HOURLY_LIMIT_EXCEED: "Hourly limit cannot exceed more than 100",
  DAILY_LIMIT_EXCEED: "Daily limit cannot exceed more than 1000",
  HOUR_LIMIT_DAILY: "Hour limit cannot more than Daily limit",
  BACK_COLOR: "Background Color",
  BRANDING_CREATE_SUCCESS: "Branding Created Successfully ",
  BRANDING_UPDATE_SUCCESS: "Branding Created Successfully ",
  BRANDING_DELETE_SUCCESS: "Branding Deleted Successfully ",
  DAILY: "Daily",
  SUCCESS_DELETE: "Successfully Deleted",
  SERVER_MESSAGE: "Server Message Misplaced.",
  PRIORITY_NAME: "Priority*",
  SOMETHING_WENT_WRONG: "Something went wrong!",
  MAX_SEC: "You have reached your limit to create branding kits  ",
  CANCEL: "Cancel",
  PRIMARY: "Primary",
  ERR_MESSAGE:
    "The image you are trying to upload exceeds the maximum allowed size of 200 KB.   ",
  UPDATE: "Update",
  SAVE: "Save",
  DRAG: "or drag and drop PNG,",
  JPG_IMAGE: "JPG (max. 200kb)",
  CLICK_UPLOAD: "Click to upload",
  REQUIRED: "This field is required",
  WRITE_BRAND: "Write Your Brand Kit Name",
  SECONDARY: "Secondary",
  BRANDING: "Branding",
  MY_BRAND: "My Brand Kits",
  BRAND_NAME: "Brand Kit Name*",
  COLORS: "Colors",
  BRANDING_DESC:
    "Set your logo and colors for tools where you can show your branding. These settings will help you quickly choose brand options when creating public facing content.",
  DELETE: "Delete",
  CREATE_BRAND: " Create a new brand kit",
  DIS_GMAIL: "Disconnect Gmail",
  ARE_YOU_SURE_DISCONNECT: "Are you sure you want to Disconnect?",
  CONNECT_MAILBOX_TITLE: "Connect mailbox",
  CONNECT_MAILBOX_DESC:
    "is disconnected, so it can't send or receive right now. Connecting takes you to your email provider to sign in again.",
  CONNECT_MAILBOX_KEEPS_DATA:
    "Your sending limits, signatures and campaign history stay as they are.",
  YOUR_EMAIL_PROVIDER: "This mailbox",
  DISCONNECT_HAS_SIGNATURES_TITLE: "Delete signatures first",
  DISCONNECT_HAS_SIGNATURES_DESC:
    "This mailbox still has one or more signatures. Please delete them under Email Signatures before disconnecting the mailbox.",
  DISCONNECT_HAS_SIGNATURES_BANNER:
    "Delete this mailbox's signatures under Email Signatures, then try again.",
  DISCONNECT_SIG_CHECK_FAILED:
    "Couldn't verify this mailbox's signatures. Please try again.",
  ENTER_API: "Enter API Key",
  GMAIL_LIMIT: "Gmail Email Limit",
  ENTER_DOMAIN: "Enter Domain",
  SENDGRID_EMAIL_LIMIT: "SendGrid Email Sending Limit",
  GOOGLE_SIGN: "Sign In with Google",
  GMAIL_EMAIL_SENDING: "Gmail Email Sending Limit",
  DISCONNECT: "Disconnect",
  MAILGUN_LIMIT: "Mailgun Email Sending Limit",

  COMMON_SAVE: "Save",
  CONNECT_WITH_APPS: "Connect with Apps",
  IS_CONNECT: "No Google tokens found",
  DATA_MANAGEMENT: "Data Management",
  SECURITY: "Security",
  SECURITY_DESC: "This applies across any ReachIQ accounts you have.",
  UPDATE_PASSWORD: "Update Password",
  PASSWORD: "Change Password",
  ERROR: "error",
  DEFAULT: "default",
  SETTING: "Settings",
  PREFERENCE: "Your Preference",
  ACC_SETUP: "Account Setup",
  INVITE_USER: "Invite Users",
  INVITED_USERS: "Pending Invitation",
  INVITE_DESC:
    "  Create new users, customize user permissions, and remove users from your account.",
  USERS_DESC:
    " Create new users, customize user permissions, and remove users from your account.",
  USERS: "Users",
  SAVED_CONTACTS: "Saved Contacts",
  CONNECTED: "Connected",
  ALLAPPS: "All Apps",
  ALLAPPSID: "all_apps",
  HEADING: "Connect with Apps",
  SUBHEADING: "This applies across any ReachIQ accounts you have",
  BUTTONSTRING: "connect",
  EMIALSENDINGLIMIT: "Email Sending Limits",
  EDIT: "Edit",
  // Gmail send-as alias picker (only shown for mailboxes that have verified aliases)
  SENDING_AS: "Sending as",
  SENDING_AS_HINT:
    "Campaign emails go out from this address. Replies still arrive in this mailbox, and the sending limits stay shared with it.",
  SENDING_AS_CONFIRM_1: "Campaign emails from this mailbox will be sent as",
  SENDING_AS_CONFIRM_2:
    "This choice is locked once set — to change it later you will have to disconnect and reconnect the mailbox. Continue?",
  SENDING_AS_LOCKED_HINT:
    "The sending address is locked. To change it, disconnect the mailbox and connect it again.",
  HOURLY: "Hourly",
  DAILY: "Daily",
  HOURLYNO: "100",
  DAILYNO: "250",
  SET_EMAIL_LIMIT: "Set Email Limit",
  CANCEL: "Cancel",
  SAVE: "Save",
  CONNECT_GMAIL: "Connect your Gmail inbox",
  API_KEY: "API Key",
  PERMISSION: "Permissions",
  CONNECT: "Connect",
  DISABLED: "disabled",
  CONNECT_OUTLOOK: "Connect your Outlook",
  INBOX_ADDED: "Inbox Added",
  NOT_CONNECTED: "Not connected",
  ADD: "Add",
  API_KEY: "API Key*",
  EMAIL: "Email*",
  ENTR_EML: "Enter email",
  DOMAIN: "Domain*",
  MAKE_IT_PRIMARY: "Make it Primary",
  NO_RECORD_FOUND: "No Record Found",
  DAILY_LIMIT_WARNING:
    "Sending more than 50 emails a day may impact deliverability.",
  MAILBOX_CONNECTED_ONE: "mailbox connected",
  MAILBOX_CONNECTED_OTHER: "mailboxes connected",
  INTEGRATIONS: "Integrations",
  GENERAL: "General",
  OLD_PASSWORD: "Old Password*",
  NEW_PASSWORD: "New Password*",
  CONFIRM_PASSWORD: "Confirm New Password*",
  SEND_TEST_MAIL: "Send test mail",
  NAME: "Name*",
  ENTR_NAME: "Enter name",
  US: "US",
  EU: "EU",
  REGION: "Region*",
  PULL: "Pull signature",
  EMAIL_SIGNATURE: "Email signature",
  EDIT_SIGNATURE: "Edit signature",
  PULL_SIGN: "Extract from Gmail",
  SAVE_CHG: "Save Changes",
  FORMS: "Forms",
  FORMS_DESC: "Modify and Update fields on different forms within ReachIQ.",
  SELECT_FORM: "Select a form:",
  CONTACTS_SMALL: "contacts",
  ACCOUNTS_SMALL: "accounts",
  DEALS_SMALL: "deals",
  ADD_PROPERTIES_SMALL: "add_properties",
  ADD_PROPERTIES: "Add Properties",
  ADD_ASSOCIATIONS_SMALL: "add_associations",
  ADD_ASSOCIATIONS: "Add Assocations",
  OTHER: "Other",
  CONTACT: "Contact",
  PREVIEW: "Preview",
  PREVIEW_SMALL: "preview",
  SEARCH: "Search...",
  DATE_PICKER: "Date Picker",
  NUMBER: "Number",
  MULTI_LINE_TEXT_INPUT: "Multi-line Text Input",
  RICH_TEXT_EDITOR: "Rich Text Editor",
  MULTIPLE_SELECT: "Multiple Select",
  SINGLE_SELECT: "Single Select",
  COMPANY: "Company",
  DEALS: "Deals",
  ASSOCIATED_CONTACT_SMALL: "associated_contact",
  ASSOCIATED_COMPANY_SMALL: "associated_company",
  INSTRUCTIONS: "Instructions",
  DESC_INST2: "2. Upload the image in both PNG and JPG (Max 200KB).",
  DESC_INST1: "1. Image width must be precisely 350 pixels.",
  SELECT_ALL: "Select All",
  BILLING: "Billing",
  DATA_REPORTS: "Daily Activity Reports",
  GET_STARTED: "Get Started",

  // ─── Mailbox sending-usage modal ───────────────────────────────────────
  VIEW_USAGE: "View Usage",
  SENDING_USAGE: "Sending Usage",
  MAILBOX_USAGE_DESC: "Live send counts read from the rate-limit buckets.",
  HOURLY_USAGE: "Hourly Usage",
  DAILY_USAGE: "Daily Usage",
  SENT: "Sent",
  LIMIT: "Limit",
  REMAINING: "Remaining",
  NEXT_HOURLY_RESET: "Next hourly reset",
  NEXT_DAILY_RESET: "Next daily reset",
  NEXT_SEND_ALLOWED: "Next send allowed",
  IN_MINUTES_SUFFIX: "min",
  USAGE_NO_SENDS_TITLE: "No emails sent yet",
  USAGE_NO_SENDS_DESC:
    "Usage will appear here once this mailbox sends its first email.",
  USAGE_FETCH_ERROR: "Couldn't load sending usage. Please try again.",
  CLOSE: "Close",

  // Edit-inbox sending-limit hard caps
  HOURLY_WITH_MAX: "Hourly (max 10)",
  DAILY_WITH_MAX: "Daily (max 100)",

  // Blocked when a mailbox is mid-send (daily.sent > 0)
  EDIT_BLOCKED_WHILE_SENDING:
    "You can't change the sending limits while this mailbox is sending emails. Please try again once the daily window resets.",

  // Connection-state chip on each row of the Integrations tab. Driven by
  // `mailbox_status` from get-api-details (falls back to `status`).
  MAILBOX_STATUS_CONNECTED: "Connected",
  MAILBOX_STATUS_CONNECTING: "Connecting",
  MAILBOX_STATUS_DISCONNECTED: "Disconnected",
  MAILBOX_STATUS_CONNECTED_HINT: "This mailbox is connected and can send emails.",
  MAILBOX_STATUS_CONNECTING_HINT:
    "This mailbox is still being set up, so it can't send emails yet.",
  MAILBOX_STATUS_DISCONNECTED_HINT:
    "This mailbox is disconnected. Reconnect it to resume sending.",
};
